module.exports = __webpack_public_path__ + "static/media/truck-monster.5d163d7d.svg";